import { Language } from '../i18n/translations';
import { Species } from '../contexts/SettingsContext';

export interface LanguageOption {
  code: Language;
  name: string;
  flag: string;
}

export interface SpeciesOption {
  code: Species;
  translationKey: string;
}

/**
 * Available languages in the application
 */
export const AVAILABLE_LANGUAGES: LanguageOption[] = [
  { code: 'sv', name: 'Svenska', flag: '🇸🇪' },
  { code: 'en', name: 'English', flag: '🇬🇧' },
  { code: 'da', name: 'Dansk', flag: '🇩🇰' },
  { code: 'no', name: 'Norsk', flag: '🇳🇴' },
  { code: 'fi', name: 'Suomi', flag: '🇫🇮' },
];

/**
 * Available fish species in the application
 */
export const AVAILABLE_SPECIES: SpeciesOption[] = [
  { code: 'pike', translationKey: 'pike' },
  { code: 'perch', translationKey: 'perch' },
  { code: 'zander', translationKey: 'zander' },
  { code: 'trout', translationKey: 'trout' },
  { code: 'salmon', translationKey: 'salmon' },
  { code: 'seaTrout', translationKey: 'seaTrout' },
  { code: 'general', translationKey: 'general' },
];

/**
 * Default settings
 */
export const DEFAULT_SETTINGS = {
  language: 'sv' as Language,
  unitSystem: 'metric' as 'metric' | 'imperial',
  species: 'pike' as Species,
};
